import templateEdit from '../../../pages/Template/modules/template-edit'
import templateApi from '../../../api/template.api'
import Iloading from '@/assets/images/i-loading.png'
import _ from 'lodash'

const getters = {
	getLocalJqueryPath: () => {
		return templateApi.getLocalJqueryPath()
	},
	getIframeUrl: state => {
		return templateApi.getIframeUrl(state.projId, state.pageId)
	},
	getIframePageUrl: state => (pageId = '') => {
		return templateApi.getIframeUrl(state.projId, pageId)
	},

	// 获取当前页面base路径
	getBasePath: (state, getters, rootState) => {
		return (
			(rootState.basImagePath || rootState.globals.basImagePath) +
			state.projId +
			'/' +
			state.indexPageId +
			'/'
		)
	},
	// 获取当前页面图片路径
	getPageImgUrl: (state, getters, rootState) => url => {
		if (!url) {
			return Iloading
		}
		if (/\/link_repl_fix\/images\/image-empty.png/.test(url)) {
			return rootState.globals.basImagePath + 'images/image-empty.png'
		}
		return /^https?:\/\//i.test(url) ? url : getters.getBasePath + url
	},
	// 截断basePath
	filterImgPath: (state, getters) => src => {
		return /^https?:\/\//i.test(src) ? src : getters.getBasePath + src
	},
	// 获取弹层input前面要显示的label
	getAttrTitle: () => attrKey => {
		switch (attrKey) {
		case 'src':
			return '图片'
		case 'css':
			return '背景图片'
		case 'text':
			return '文字内容'
		case 'title':
			// return '超链接title'
			return '链接提示'
		case 'alt':
			// return '自定义alt'
			return '图片描述'
		case 'href':
			return '链接地址'
		case 'target':
			return ' ' //打开方式
		case 'placeholder':
		case 'value':
			return '文本提示'
		case 'rel':
			return 'nofollow'
		}
	},
	filterOptions: state => (options, hasWrap, isOpen, hasLineFeed) => {
		return templateEdit(
			state.projId,
			state.indexPageId,
			state.jquery,
			options,
			hasWrap,
			isOpen,
			hasLineFeed
		)
	},
	formatPageName: state => (value, dataNav) => {
		let pageName = value
		if (!value) {
			pageName = '请输入网址，以http://开头'
			return pageName
		}
		dataNav.forEach(item => {
			if (item.htmlName === value) {
				pageName = item.pageName
			}
		})
		return pageName
	},
	getImgRadio: state => {
		let [m, n] = state.imgSize
		let min = m > n ? n : m
		let max = 0,
			arr = []
		for (let i = 0; i <= min; i++) {
			if (n % i == 0 && m % i == 0) {
				arr.push(i)
			}
		}
		for (let i = 0; i < arr.length; i++) {
			if (arr[i] > arr[i + 1]) {
				arr[i] = [arr[i + 1], (arr[i + 1] = arr[i])][0]
			}
		}
		max = arr[arr.length - 1]
		let radio = m / max + ':' + n / max
		if (radio === '1:2' || radio === '2:1' || radio === '1:1') {
			return radio
		}
		if (
			Math.round((m / 16) * 9) === n ||
			Math.ceil((m / 16) * 9) === n ||
			Math.floor((m / 16) * 9) === n
		) {
			radio = '16:9'
		}
		if (
			Math.round((m / 9) * 16) === n ||
			Math.ceil((m / 9) * 16) === n ||
			Math.floor((m / 9) * 16) === n
		) {
			radio = '9:16'
		}
		if (
			Math.round((m / 3) * 4) === n ||
			Math.ceil((m / 3) * 4) === n ||
			Math.floor((m / 3) * 4) === n
		) {
			radio = '3:4'
		}
		if (
			Math.round((m / 4) * 3) === n ||
			Math.ceil((m / 4) * 3) === n ||
			Math.floor((m / 4) * 3) === n
		) {
			radio = '4:3'
		}
		return radio
	},
	getImgSizeType: (state, getters) => {
		let common = [
			{
				radio: '1:1',
				sizeType: {
					zero: [1920, 1920],
					one: [1200, 1200],
					two: [700, 700]
				}
			},
			{
				radio: '2:1',
				sizeType: {
					zero: [1920, 960],
					one: [1200, 600],
					two: [700, 350]
				}
			},
			{
				radio: '4:3',
				sizeType: {
					zero: [1920, 1440],
					one: [1200, 900],
					two: [700, 525]
				}
			},
			{
				radio: '16:9',
				sizeType: {
					zero: [1920, 1080],
					one: [1200, 675],
					two: [700, 394]
				}
			},
			{
				radio: '3:4',
				sizeType: {
					zero: [1440, 1920],
					one: [900, 1200],
					two: [525, 700]
				}
			},
			{
				radio: '9:16',
				sizeType: {
					zero: [1080, 1920],
					one: [675, 1200],
					two: [394, 700]
				}
			},
			{
				radio: '1:2',
				sizeType: {
					zero: [960, 1920],
					one: [600, 1200],
					two: [350, 700]
				}
			}
		]
		let filterObj = _.filter(common, {
			radio: getters.getImgRadio
		})[0]
		if (!filterObj) {
			console.log('没有对应比例的图片')
			return
		}
		let [width, height] = state.imgSize,
			sizeType = filterObj.sizeType
		if (width <= sizeType['two'][0] && height <= sizeType['two'][1]) {
			return '2' //小图
		}
		if (
			width > sizeType['two'][0] &&
			height > sizeType['two'][1] &&
			width <= sizeType['one'][0] &&
			height <= sizeType['one'][1]
		) {
			return '1' // 中途
		}
		if (width <= sizeType['zero'][0] && height <= sizeType['zero'][1]) {
			return '0'
		}
	},
	/**
	 * 获取所有页面，或者对应页面信息
	 */
	allNavList: state => id => {
		let arrData = [],
			curPage = {}
		state.pageNavList.forEach(item => {
			if (id === item.navPageId) {
				curPage = item
			}
			arrData.push(item)
			item.children &&
				item.children.forEach(list => {
					arrData.push(list)
					if (id === list.navPageId) {
						curPage = list
					}
				})
		})
		if (id) {
			return curPage
		}
		return arrData
	},
	getLeftPageSelect: (state, getters) => {
		let arr = []
		getters.allNavList().forEach(item => {
			if (
				item.pageType === '首页' ||
				item.pageType === '文章列表页' ||
				item.pageType === '产品列表页'
			) {
				item.pageType === '首页' ? (item.cur = true) : (item.cur = false)
				item.pageType === '首页' ? (item.title = '点击选取首页链接' ) : (item.title = '点击展开分类和详情')

				arr.push(item)
			}
		})
		arr.push(
			{
				pageType: '关于我们',
				cur: false,
				navPageName: '关于我们',
				title: '点击展开关于页面'
			},
			{
				pageType: '其他页面',
				cur: false,
				navPageName: '其他页面',
				title: '点击展开其他页面'
			}
		)
		return arr
	},
	getAboutTypePage: (state, getters) => {
		let arr = []
		getters.allNavList().forEach(item => {
			if (item.pageType === '介绍页' || item.pageType === '联系页') {
				arr.push(item)
			}
		})
		return arr
	},
	getOtherTypePage: (state, getters) => {
		let arr = []
		getters.allNavList().forEach(item => {
			if (item.pageType === '其他单页' || item.pageType === '外链') {
				arr.push(item)
			}
		})
		return arr
	},
	getCatePage: (state, getters) => {
		let arr = []
		state.categoryPageData.forEach(item => {
			if (item.pageType === state.pageSelectCur.pageType) {
				arr.push(item)
			}
		})
		return arr
	},
	// 根据路径获取对应页面的数据
	getPageNavData: (state, getters) => path => {
		if (path.includes(state.pageUrl)) {
			path =
				path.substring(('http://' + state.pageUrl).length + 1) ||
				'index.html'
		}
		let navPageData = getters.allNavList().find(item => {
			return item.navPagePath === path
		})
		return navPageData
	},

	getProbeLink: (state, getters) => {
		return [
			{
				navPageName: '网站页面',
				navPagePath: '',
				code: 'sitePage',
				point: ''
			},
			{
				navPageName: '自定义',
				navPagePath: '',
				code: 'customize',
				point: '请输入网址，以http://开头'
			},
			{
				navPageName: 'QQ询盘探头',
				navPagePath: 'http://wpa.qq.com/msgrd?v=3&uin=',
				code: 'qq',
				point: '请填写QQ号码，如：10295758'
			},
			{
				navPageName: '拨打电话',
				navPagePath: 'tel:',
				code: 'tel',
				point: '请填写电话号码，如：0755-83765760'
			},
			{
				navPageName: '电子邮件',
				navPagePath: 'mailto:',
				code: 'email',
				point: '请填写电子邮件，如：10295758@qq.com'
			}
		]
	},
	handleProbeLink: (state, getters) => arr => {
		arr.forEach((item, index) => {
			item.index = index
		})
		return arr
	},
	handleNavCategory: (state, getters) => curType => {
		let arr = []
		let pageType = curType === 'product' ? '产品列表页' : '文章列表页'

		function handleFn(navArr, order) {
			navArr.forEach(navItem => {
				if (navItem.pageType !== pageType) {
					return
				}
				navItem.retract = order
				arr.push(navItem)
				if (navItem.children && navItem.children.length > 0) {
					handleFn(navItem.children, 2)
				}
			})
		}
		handleFn(state.categoryPageData, 1)
		return arr
	}
}

export default getters
